import api, { ApiResponse } from "./../api";
import { FeedbackRequestModel } from "./models";

class FeedbackService {
  private static instance: FeedbackService;

  private constructor() { }

  static getInstance(): FeedbackService {
    if (!FeedbackService.instance) {
      FeedbackService.instance = new FeedbackService();
    }

    return FeedbackService.instance;
  }

  public submitJiraFeedback = async (
    data: FeedbackRequestModel
  ): Promise<ApiResponse<any>> => {
    const formData = new FormData();
    formData.append("rating", String(Number(data.rating)));
    formData.append("comments", data.comments);
    if (data.attachments) {
      data.attachments.forEach((file) => formData.append("attachments", file));
    }
    if (data.page) {
      formData.append("page", data.page);
    }
    return await api.post("/jira/feedback", formData);
  };

  public getSubjects = async (): Promise<ApiResponse<any>> => {
    return await api.get("/feedback/subjects");
  };
}

export default FeedbackService;
